import { NAME_SPACES } from "shared/locales/constants";
import account from "./account";

const translation = {
  [NAME_SPACES.PRIVATE.XO.ACCOUNT]: account,
};

export default translation;
